const RISK_LEVELS = {
  "01": "Low",
  "05": "Medium",
  "07": "High",
  "00": "Not Rated"
} as const;

export type RiskRatingResult = {
  calculatedRiskLevel: (typeof RISK_LEVELS)[keyof typeof RISK_LEVELS] | "Unknown",
  calculatedRiskRatingDate: number;
}

export function riskRatingResultTransformer(data: any): RiskRatingResult {
  return {
    calculatedRiskLevel: getRiskLevelByCode(data.fsoPartyRiskLevelIdCurr),
    calculatedRiskRatingDate: data.riskAssessmentDate,
  };
}

export function getRiskLevelByCode(code: string): (typeof RISK_LEVELS)[keyof typeof RISK_LEVELS] | "Unknown" {
  const level = RISK_LEVELS[code as keyof typeof RISK_LEVELS];
  if (!level) {
    return "Unknown";
  }
  return level;
}

